import * as css from './Animation.css';
import React, {useEffect, useRef} from 'react';

interface AnimationProps {
    animation: any;
    isLoop?: boolean;
    cssStyle?: string;
}

const Animation = React.memo(function Animation({animation, isLoop = true, cssStyle}: AnimationProps) {
    const ref = useRef(null);
    useEffect(() => {
        // lottie-web is ~280KB minified — loaded on demand to keep it out of main.js
        let instance = null;
        let cancelled = false;
        import('lottie-web').then(({default: lottie}) => {
            if(cancelled || !ref.current)
                return;
            instance = lottie.loadAnimation({
                container: ref.current,
                loop: isLoop,
                animationData: animation,
            });
        });
        return () => {
            cancelled = true;
            instance?.destroy();
        };
    }, []);

    return (
        <css.animate className='animation' $cssStyle={cssStyle} data-cy='animation'>
            <div ref={ref} />
        </css.animate>
    );
});

export default Animation;
